<template>
    <div :class="containerClassName">
        <div :class="itemClassName"
            v-for="theme in themes"
            :key="theme.hash">
            <Theme
                :onThemeClick="onThemeClick"
                :getImageThemeUrl="getImageThemeUrl"
                :theme="theme"
            />
        </div>
    </div>
</template>

<script>
import { getImageThemeUrl } from '../../services/MapsfyApi';

import Theme from './Theme';
export default {
    components: {
        Theme
    },
    props: {
        onThemeClick: {
            type: Function,
            required: true
        },
        themes: {
            type: Array,
            required: true
        },
        containerClassName: {
            type: String,
            required: true
        },
        itemClassName: {
            type: String,
            required: true
        }
    },
    methods: {
        getImageThemeUrl: getImageThemeUrl
    }
}
</script>